export default "__VITE_ASSET__Djc0nxS5__"